export default "__VITE_ASSET__BvkJeCqj__"